import styled from 'styled-components';

export const MainWrap = styled.div<{ rtl?: boolean }>`
  &.bl-ticket-order {
    width: 50%;
    display: inline-block;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
    padding: 26px 50px 0 53px;
    height: auto;
    padding-bottom: 34px;
    align-self: flex-start;

    .bl-ticket-order-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 8px;
    }

    .bl-ticket-order-subTitle {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 10px;
      color: #828282;
    }

    .bl-ticket-order-pills {
      margin-bottom: 15px;
      display: flex;
      flex-wrap: wrap;

      .bl-ticket-order-pill {
        display: flex;
        align-items: center;
        border: 0.5px solid #d7d7d7;
        box-sizing: border-box;
        box-shadow: 0 0.5px 0 1px rgba(0, 0, 0, 0.16);
        border-radius: 16px;
        padding: 4px 18px;
        margin-right: 7px;
        margin-bottom: 7px;

        img {
          width: 15px;
          height: 15px;
        }
      }
    }

    .bl-ticket-order-private-note-wrap {
      border: 1px solid #d7d7d7;
      box-sizing: border-box;
      border-radius: 3px;
      padding: 10px 12px 4px 20px;
      position: relative;
      margin-bottom: 16px;

      .bl-ticket-order-pnote-header {
        display: inline-block;
        position: absolute;
        top: -10px;
        background-color: white;
        color: #828282;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        ${({ rtl }) => `${rtl ? 'right: 26px;' : ''}`};
      }

      .bl-ticket-order-pnote-content {
        font-weight: 300;
        font-size: 12px;
        line-height: 21px;
      }
    }

    .bl-ticket-order-price {
      display: flex;

      .bl-ticket-order-price-title {
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
        white-space: nowrap;
      }

      .bl-ticket-order-price-line {
        border-style: dashed;
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }

      .bl-ticket-order-price-cost {
      }
    }

    .bl-ticket-order-after-disc-line {
    }

    .bl-ticket-order-gtotal {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 19px;

      .bl-ticket-order-gtotal-title {
      }

      .bl-ticket-order-gtotal-price {
      }
    }

    .bl-ticket-order-checkboxes {
      label {
        display: flex;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        align-items: baseline;
        margin-bottom: 10px;

        input[type='checkbox'] {
          margin-right: 8px;
          line-height: 20px;
          width: 12px;
          height: 12px;
          accent-color: #ea475c;
          border-radius: 2px;
          ${({ rtl }) => `${rtl ? 'margin: 0 8px;' : ''}`};
        }
      }
    }

    .bl-ticket-order-pay-btn {
      background: linear-gradient(137.27deg, #ea475c 19.41%, #ff6175 65.49%);
      box-shadow: 0px 4px 4px rgba(14, 53, 191, 0.25);
      border-radius: 12px;
      color: #f6f6f6;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;

      padding: 12px 109px;
      margin: auto;
      display: block;
      margin-top: 29px;

      &:active {
        opacity: 0.9;
      }

      &:disabled {
        background: #8b8b8b;
      }
    }
  }
`;
